import { combineReducers } from 'redux';

import { auth } from './auth';
import { notifications } from './notifications';
import { userRights } from './rights';
import { lists } from './lists';
import { slas } from './slas';
import { toasts } from './toasts';
import { machineConfig, tokens } from './token';
import { application } from './application';
import { formReducer } from './forms';

const rootReducer = combineReducers({
  auth,
  userRights,
  lists,
  slas,
  toasts,
  machineConfig,
  tokens,
  application,
  notifications,
  form: formReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
